module.exports = __webpack_public_path__ + "images/category_lp/tablet/assessment_achievements/6_787db675750fc2f7edb61ceee3dad8bf.jpg";